import React, { memo } from 'react'

import './icons.less'

export type IconName =
  | 'house'
  | 'copyright'
  | 'yellowSquare'
  | 'redSquare'
  | 'greenSquare'
  | 'buttonLogin'
  | 'inputSms'
  | 'inputLock'
  | 'inputPasswordEyeClosed'
  | 'inputPasswordEyeOpen'
  | 'inputProfileCircle'
  | 'key'
  | 'buttonArrowRight'
  | 'buttonRight'
  | 'courthouse'
  | 'checkWhite'
  | 'userOctagon'
  | 'profile2user'
  | 'updateData'
  | 'dataFlow'
  | 'messageQuestion'
  | 'code'
  | 'infoCircle'
  | 'refresh'
  | 'firstLine'
  | 'flashWhite'
  | 'messageQuestionTwoTone'
  | 'dislike'
  | 'like'
  | 'arrowDown'
  | 'profileUser'
  | 'copyUrl'
  | 'infoCirclePlainDesigned'
  | 'knowledgeBase'
  | 'agents'
  | 'conversations'
  | 'accountMenu'
  | 'arrowUp'
  | 'share'
  | 'editData'
  | 'trash'
  | 'pencil'
  | 'synchronization'
  | 'cross'
  | 'history'
  | 'reports'
  | 'send'
  | 'menu'
  | 'newChat'
  | 'accounts'
  | 'burgerMenu'
  | 'paperClip'

interface Props {
  name: IconName
  fill?: string
  stroke?: string
  className?: string
  style?: object
  width?: number
  height?: number
  onClick?: () => void
}

const Icon = ({ name, className, style, fill, stroke, ...props }: Props) => {
  const icons = {
    house: (
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.0001 8.00001L14.0001 2.74001C13.4501 2.24805 12.738 1.97607 12.0001 1.97607C11.2622 1.97607 10.5501 2.24805 10.0001 2.74001L4.00009 8.00001C3.68246 8.28408 3.42899 8.63256 3.25657 9.02225C3.08414 9.41194 2.99671 9.83389 3.00009 10.26V19C3.00009 19.7957 3.31617 20.5587 3.87877 21.1213C4.44138 21.6839 5.20445 22 6.00009 22H18.0001C18.7957 22 19.5588 21.6839 20.1214 21.1213C20.684 20.5587 21.0001 19.7957 21.0001 19V10.25C21.0021 9.82557 20.9139 9.40555 20.7416 9.01769C20.5692 8.62983 20.3165 8.28296 20.0001 8.00001V8.00001ZM14.0001 20H10.0001V15C10.0001 14.7348 10.1055 14.4804 10.293 14.2929C10.4805 14.1054 10.7349 14 11.0001 14H13.0001C13.2653 14 13.5197 14.1054 13.7072 14.2929C13.8947 14.4804 14.0001 14.7348 14.0001 15V20ZM19.0001 19C19.0001 19.2652 18.8947 19.5196 18.7072 19.7071C18.5197 19.8946 18.2653 20 18.0001 20H16.0001V15C16.0001 14.2044 15.684 13.4413 15.1214 12.8787C14.5588 12.3161 13.7957 12 13.0001 12H11.0001C10.2044 12 9.44138 12.3161 8.87877 12.8787C8.31617 13.4413 8.00009 14.2044 8.00009 15V20H6.00009C5.73488 20 5.48052 19.8946 5.29299 19.7071C5.10545 19.5196 5.00009 19.2652 5.00009 19V10.25C5.00027 10.108 5.03069 9.9677 5.08931 9.83839C5.14794 9.70907 5.23343 9.59372 5.3401 9.50001L11.3401 4.25001C11.5226 4.08969 11.7572 4.00127 12.0001 4.00127C12.243 4.00127 12.4776 4.08969 12.6601 4.25001L18.6601 9.50001C18.7668 9.59372 18.8523 9.70907 18.9109 9.83839C18.9695 9.9677 18.9999 10.108 19.0001 10.25V19Z"
          fill="black"
        />
      </svg>
    ),
    copyright: (
      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.4"
          d="M12 22.5C6.48 22.5 2 18.02 2 12.5C2 6.98 6.48 2.5 12 2.5C17.52 2.5 22 6.98 22 12.5C22 18.02 17.52 22.5 12 22.5Z"
          fill="#7169FB"
        />
        <path
          d="M12.24 17.25C9.61999 17.25 7.48999 15.12 7.48999 12.5C7.48999 9.88 9.61999 7.75 12.24 7.75C13.39 7.75 14.51 8.17 15.37 8.94C15.68 9.21 15.71 9.69 15.44 10C15.16 10.31 14.69 10.34 14.38 10.07C13.79 9.55001 13.03 9.26001 12.24 9.26001C10.45 9.26001 8.98999 10.72 8.98999 12.51C8.98999 14.3 10.45 15.76 12.24 15.76C13.02 15.76 13.79 15.47 14.38 14.95C14.69 14.68 15.17 14.71 15.44 15.02C15.71 15.33 15.68 15.81 15.37 16.08C14.5 16.83 13.39 17.25 12.24 17.25Z"
          fill="#7169FB"
        />
      </svg>
    ),
    buttonLogin: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.6799 14.56L14.2399 12L11.6799 9.44"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 12H14.17"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 12H5.96"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.01 6.48001C19.25 7.84001 20 9.71001 20 12C20 17 16.42 20 12 20"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 4C13.05 4 14.05 4.17 14.97 4.49"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    inputSms: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.4" d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z" fill="#93AEE0" />
        <path
          d="M12 12.87C11.16 12.87 10.31 12.61 9.66003 12.08L6.53002 9.57997C6.21002 9.31997 6.15003 8.84997 6.41003 8.52997C6.67003 8.20997 7.14003 8.14997 7.46003 8.40997L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L16.53 8.40997C16.85 8.14997 17.33 8.19997 17.58 8.52997C17.84 8.84997 17.79 9.32997 17.46 9.57997L14.33 12.08C13.69 12.61 12.84 12.87 12 12.87Z"
          fill="#3F78E0" />
      </svg>
    ),
    inputLock: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.75 8V10.1C18.31 10.04 17.81 10.01 17.25 10V8C17.25 4.85 16.36 2.75 12 2.75C7.64 2.75 6.75 4.85 6.75 8V10C6.19 10.01 5.69 10.04 5.25 10.1V8C5.25 5.1 5.95 1.25 12 1.25C18.05 1.25 18.75 5.1 18.75 8Z"
          fill="#7169FB"
        />
        <path
          opacity="0.4"
          d="M22 15V17C22 21 21 22 17 22H7C3 22 2 21 2 17V15C2 11.66 2.7 10.41 5.25 10.1C5.69 10.04 6.19 10.01 6.75 10H17.25C17.81 10.01 18.31 10.04 18.75 10.1C21.3 10.41 22 11.66 22 15Z"
          fill="#7169FB"
        />
        <path
          d="M8 17C7.87 17 7.74 16.97 7.62 16.92C7.49 16.87 7.39001 16.8 7.29001 16.71C7.11001 16.52 7 16.26 7 16C7 15.87 7.02999 15.74 7.07999 15.62C7.12999 15.5 7.20001 15.39 7.29001 15.29C7.39001 15.2 7.49 15.13 7.62 15.08C7.99 14.92 8.42999 15.01 8.70999 15.29C8.79999 15.39 8.87001 15.5 8.92001 15.62C8.97001 15.74 9 15.87 9 16C9 16.26 8.88999 16.52 8.70999 16.71C8.51999 16.89 8.26 17 8 17Z"
          fill="#7169FB"
        />
        <path
          d="M12 17C11.73 17 11.48 16.89 11.29 16.71C11.2 16.61 11.13 16.5 11.08 16.38C11.03 16.26 11 16.13 11 16C11 15.73 11.11 15.48 11.29 15.29C11.66 14.92 12.33 14.92 12.71 15.29C12.89 15.48 13 15.73 13 16C13 16.13 12.97 16.26 12.92 16.38C12.87 16.5 12.8 16.61 12.71 16.71C12.52 16.89 12.26 17 12 17Z"
          fill="#7169FB"
        />
        <path
          d="M16 17C15.74 17 15.48 16.89 15.29 16.71C15.11 16.52 15 16.27 15 16C15 15.73 15.11 15.48 15.29 15.29C15.67 14.92 16.34 14.92 16.71 15.29C16.75 15.34 16.79 15.39 16.83 15.45C16.87 15.5 16.9 15.56 16.92 15.62C16.95 15.68 16.97 15.74 16.98 15.8C16.99 15.87 17 15.94 17 16C17 16.26 16.89 16.52 16.71 16.71C16.52 16.89 16.26 17 16 17Z"
          fill="#7169FB"
        />
      </svg>
    ),
    inputPasswordEyeClosed: (
      <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.4"
          d="M14.1666 6.1C13.8399 5.58 13.4666 5.11333 13.0799 4.69333L10.5666 7.20666C10.6466 7.45333 10.6932 7.72 10.6932 8C10.6932 9.49333 9.48657 10.6933 7.9999 10.6933C7.7199 10.6933 7.45324 10.6467 7.20657 10.5667L4.8999 12.8733C5.87324 13.42 6.92657 13.7067 7.9999 13.7067C9.18657 13.7067 10.3399 13.36 11.3932 12.7133C12.4466 12.06 13.3932 11.1067 14.1666 9.89333C14.8332 8.85333 14.8332 7.14666 14.1666 6.1Z"
          fill="#0A2540"
        />
        <path
          d="M9.3466 6.65332L6.65326 9.34666C6.31326 8.99999 6.09326 8.51999 6.09326 7.99999C6.09326 6.95332 6.94659 6.09332 7.99993 6.09332C8.51993 6.09332 8.99993 6.31332 9.3466 6.65332Z"
          fill="#0A2540"
        />
        <path
          opacity="0.4"
          d="M12.1666 3.83332L9.90659 6.09332C9.41992 5.59998 8.74659 5.30665 7.99992 5.30665C6.50659 5.30665 5.30659 6.51332 5.30659 7.99998C5.30659 8.74665 5.60659 9.41998 6.09325 9.90665L3.83992 12.1667H3.83325C3.09325 11.5667 2.41325 10.8 1.83325 9.89332C1.16659 8.84665 1.16659 7.14665 1.83325 6.09998C2.60659 4.88665 3.55325 3.93332 4.60659 3.27998C5.65992 2.63998 6.81325 2.28665 7.99992 2.28665C9.48659 2.28665 10.9266 2.83332 12.1666 3.83332Z"
          fill="#0A2540"
        />
        <path
          d="M9.90672 7.99999C9.90672 9.04666 9.05339 9.90666 8.00005 9.90666C7.96005 9.90666 7.92672 9.90666 7.88672 9.89332L9.89339 7.88666C9.90672 7.92666 9.90672 7.95999 9.90672 7.99999Z"
          fill="#0A2540"
        />
        <path
          d="M14.5133 1.48667C14.3133 1.28667 13.9867 1.28667 13.7867 1.48667L1.48667 13.7933C1.28667 13.9933 1.28667 14.32 1.48667 14.52C1.58667 14.6133 1.71334 14.6667 1.84667 14.6667C1.98 14.6667 2.10667 14.6133 2.20667 14.5133L14.5133 2.20667C14.72 2.00667 14.72 1.68667 14.5133 1.48667Z"
          fill="#0A2540"
        />
      </svg>
    ),
    inputPasswordEyeOpen: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.4"
          d="M21.25 9.15005C18.94 5.52005 15.56 3.43005 12 3.43005C10.22 3.43005 8.49 3.95005 6.91 4.92005C5.33 5.90005 3.91 7.33005 2.75 9.15005C1.75 10.7201 1.75 13.2701 2.75 14.8401C5.06 18.4801 8.44 20.5601 12 20.5601C13.78 20.5601 15.51 20.0401 17.09 19.0701C18.67 18.0901 20.09 16.6601 21.25 14.8401C22.25 13.2801 22.25 10.7201 21.25 9.15005ZM12 16.0401C9.76 16.0401 7.96 14.2301 7.96 12.0001C7.96 9.77005 9.76 7.96005 12 7.96005C14.24 7.96005 16.04 9.77005 16.04 12.0001C16.04 14.2301 14.24 16.0401 12 16.0401Z"
          fill="#7169FB"
        />
        <path
          d="M12 9.14001C10.43 9.14001 9.15002 10.42 9.15002 12C9.15002 13.57 10.43 14.85 12 14.85C13.57 14.85 14.86 13.57 14.86 12C14.86 10.43 13.57 9.14001 12 9.14001Z"
          fill="#7169FB"
        />
      </svg>
    ),
    inputProfileCircle: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.4" d="M12 22.0102C17.5228 22.0102 22 17.5331 22 12.0102C22 6.4874 17.5228 2.01025 12 2.01025C6.47715 2.01025 2 6.4874 2 12.0102C2 17.5331 6.47715 22.0102 12 22.0102Z" fill="#93AEE0" />
        <path
          d="M12 6.93994C9.93 6.93994 8.25 8.61994 8.25 10.6899C8.25 12.7199 9.84 14.3699 11.95 14.4299C11.98 14.4299 12.02 14.4299 12.04 14.4299C12.06 14.4299 12.09 14.4299 12.11 14.4299C12.12 14.4299 12.13 14.4299 12.13 14.4299C14.15 14.3599 15.74 12.7199 15.75 10.6899C15.75 8.61994 14.07 6.93994 12 6.93994Z"
          fill="#3F78E0" />
        <path
          d="M18.78 19.3602C17 21.0002 14.62 22.0102 12 22.0102C9.37997 22.0102 6.99997 21.0002 5.21997 19.3602C5.45997 18.4502 6.10997 17.6202 7.05997 16.9802C9.78997 15.1602 14.23 15.1602 16.94 16.9802C17.9 17.6202 18.54 18.4502 18.78 19.3602Z"
          fill="#3F78E0" />
      </svg>

    ),
    buttonArrowRight: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.62012 3.95331L13.6668 7.99998L9.62012 12.0466"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.34009 8H13.5534"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.33325 8H4.64659"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    key: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.4"
          d="M13.1933 2.81332C11.2199 0.846651 8.01994 0.846651 6.05994 2.81332C4.67993 4.17998 4.2666 6.14665 4.79993 7.87998L1.6666 11.0133C1.4466 11.24 1.29327 11.6867 1.33993 12.0067L1.53993 13.46C1.61327 13.94 2.05993 14.3933 2.53993 14.46L3.99327 14.66C4.31327 14.7067 4.75993 14.56 4.9866 14.3267L5.53327 13.78C5.6666 13.6533 5.6666 13.44 5.53327 13.3067L4.23993 12.0133C4.0466 11.82 4.0466 11.5 4.23993 11.3067C4.43327 11.1133 4.75327 11.1133 4.9466 11.3067L6.2466 12.6067C6.37327 12.7333 6.5866 12.7333 6.71327 12.6067L8.1266 11.2C9.85327 11.74 11.8199 11.32 13.1933 9.95332C15.1599 7.98665 15.1599 4.77998 13.1933 2.81332ZM9.6666 7.99998C8.7466 7.99998 7.99993 7.25332 7.99993 6.33332C7.99993 5.41332 8.7466 4.66665 9.6666 4.66665C10.5866 4.66665 11.3333 5.41332 11.3333 6.33332C11.3333 7.25332 10.5866 7.99998 9.6666 7.99998Z"
          fill="#7169FB"
        />
        <path
          d="M9.66667 7.99999C10.5871 7.99999 11.3333 7.2538 11.3333 6.33332C11.3333 5.41285 10.5871 4.66666 9.66667 4.66666C8.74619 4.66666 8 5.41285 8 6.33332C8 7.2538 8.74619 7.99999 9.66667 7.99999Z"
          fill="#7169FB"
        />
      </svg>
    ),
    buttonRight: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.6 5.29333L10.3467 7.04C10.86 7.55334 10.86 8.39333 10.3467 8.90667L6 13.2467"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 2.69333L6.69333 3.38666"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    courthouse: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.4"
          d="M17.42 1.38002C17.21 1.24002 16.95 1.21 16.72 1.3C15.29 1.87 13.71 1.87 12.28 1.3C12.05 1.21 11.79 1.24002 11.58 1.38002C11.37 1.52002 11.25 1.75001 11.25 2.00001V5.00001V8.00001C11.25 8.41001 11.59 8.75001 12 8.75001C12.41 8.75001 12.75 8.41001 12.75 8.00001V6.02003C13.33 6.16003 13.91 6.24 14.5 6.24C15.44 6.24 16.38 6.06002 17.28 5.70002C17.56 5.59002 17.75 5.31001 17.75 5.00001V2.00001C17.75 1.75001 17.63 1.52002 17.42 1.38002Z"
          fill="#7169FB"
        />
        <path
          d="M22 21.25H20.75V11C20.75 8.58 19.42 7.25 17 7.25H7C4.58 7.25 3.25 8.58 3.25 11V21.25H2C1.59 21.25 1.25 21.59 1.25 22C1.25 22.41 1.59 22.75 2 22.75H4H20H22C22.41 22.75 22.75 22.41 22.75 22C22.75 21.59 22.41 21.25 22 21.25ZM19.25 12.75V21.25H16.74V12.75H19.25ZM11.24 21.25H8.74V12.75H11.24V21.25ZM12.74 12.75H15.24V21.25H12.74V12.75ZM4.75 12.75H7.24V21.25H4.75V12.75Z"
          fill="#7169FB"
        />
      </svg>
    ),
    checkWhite: (
      <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 4L3.99647 7L10 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    userOctagon: (
      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.2581 4.87499L11.3081 2.01666C10.4998 1.54999 9.49977 1.54999 8.68311 2.01666L3.74144 4.87499C2.93311 5.34166 2.43311 6.20832 2.43311 7.14999V12.85C2.43311 13.7833 2.93311 14.65 3.74144 15.125L8.69144 17.9833C9.49977 18.45 10.4998 18.45 11.3164 17.9833L16.2664 15.125C17.0748 14.6583 17.5748 13.7917 17.5748 12.85V7.14999C17.5664 6.20832 17.0664 5.34999 16.2581 4.87499ZM9.99977 6.11666C11.0748 6.11666 11.9414 6.98332 11.9414 8.05832C11.9414 9.13332 11.0748 9.99999 9.99977 9.99999C8.92477 9.99999 8.05811 9.13332 8.05811 8.05832C8.05811 6.99166 8.92477 6.11666 9.99977 6.11666ZM12.2331 13.8833H7.76644C7.09144 13.8833 6.69977 13.1333 7.07477 12.575C7.64144 11.7333 8.74144 11.1667 9.99977 11.1667C11.2581 11.1667 12.3581 11.7333 12.9248 12.575C13.2998 13.125 12.8998 13.8833 12.2331 13.8833Z" />
      </svg>
    ),
    profile2user: (
      <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.10671 7.24668C6.04004 7.24001 5.96004 7.24001 5.88671 7.24668C4.30004 7.19334 3.04004 5.89334 3.04004 4.29334C3.04004 2.66001 4.36004 1.33334 6.00004 1.33334C7.63337 1.33334 8.96004 2.66001 8.96004 4.29334C8.95337 5.89334 7.69337 7.19334 6.10671 7.24668Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9402 2.66666C12.2335 2.66666 13.2735 3.71332 13.2735 4.99999C13.2735 6.25999 12.2735 7.28666 11.0268 7.33332C10.9735 7.32666 10.9135 7.32666 10.8535 7.33332"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.77348 9.70666C1.16014 10.7867 1.16014 12.5467 2.77348 13.62C4.60681 14.8467 7.61348 14.8467 9.44681 13.62C11.0601 12.54 11.0601 10.78 9.44681 9.70666C7.62014 8.48666 4.61348 8.48666 2.77348 9.70666Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2266 13.3333C12.7066 13.2333 13.1599 13.04 13.5332 12.7533C14.5732 11.9733 14.5732 10.6867 13.5332 9.90668C13.1666 9.62668 12.7199 9.44001 12.2466 9.33334"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    updateData: (
      <svg width="16" height="16" viewBox="0 0 16 16" stroke={stroke} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.6665 14.6667H5.99984C3.99984 14.6667 2.6665 13.3333 2.6665 11.3333V4.66668C2.6665 2.66668 3.99984 1.33334 5.99984 1.33334H10.6665C12.6665 1.33334 13.9998 2.66668 13.9998 4.66668V11.3333C13.9998 13.3333 12.6665 14.6667 10.6665 14.6667Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M2.6665 10H13.9998" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.6665 8H5.33317" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.6665 6.33334H5.33317" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.6665 4.66666H5.33317" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.9962 12.1667H11.0022" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    dataFlow: (
      <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.8333 9.33335C14.5697 9.33335 15.1667 8.7364 15.1667 8.00002C15.1667 7.26364 14.5697 6.66669 13.8333 6.66669C13.097 6.66669 12.5 7.26364 12.5 8.00002C12.5 8.7364 13.097 9.33335 13.8333 9.33335Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8333 3.99998C14.5697 3.99998 15.1667 3.40303 15.1667 2.66665C15.1667 1.93027 14.5697 1.33331 13.8333 1.33331C13.097 1.33331 12.5 1.93027 12.5 2.66665C12.5 3.40303 13.097 3.99998 13.8333 3.99998Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8333 14.6667C14.5697 14.6667 15.1667 14.0697 15.1667 13.3333C15.1667 12.597 14.5697 12 13.8333 12C13.097 12 12.5 12.597 12.5 13.3333C12.5 14.0697 13.097 14.6667 13.8333 14.6667Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.16683 9.33335C3.90321 9.33335 4.50016 8.7364 4.50016 8.00002C4.50016 7.26364 3.90321 6.66669 3.16683 6.66669C2.43045 6.66669 1.8335 7.26364 1.8335 8.00002C1.8335 8.7364 2.43045 9.33335 3.16683 9.33335Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M4.5 8H12.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M12.5002 2.66669H9.8335C8.50016 2.66669 7.8335 3.33335 7.8335 4.66669V11.3334C7.8335 12.6667 8.50016 13.3334 9.8335 13.3334H12.5002"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    messageQuestion: (
      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.1665 2.02499H5.83317C3.33317 2.02499 1.6665 3.69166 1.6665 6.19166V11.1917C1.6665 13.6917 3.33317 15.3583 5.83317 15.3583V17.1333C5.83317 17.8 6.57484 18.2 7.12484 17.825L10.8332 15.3583H14.1665C16.6665 15.3583 18.3332 13.6917 18.3332 11.1917V6.19166C18.3332 3.69166 16.6665 2.02499 14.1665 2.02499ZM9.99984 12.1667C9.64984 12.1667 9.37484 11.8833 9.37484 11.5417C9.37484 11.2 9.64984 10.9167 9.99984 10.9167C10.3498 10.9167 10.6248 11.2 10.6248 11.5417C10.6248 11.8833 10.3498 12.1667 9.99984 12.1667ZM11.0498 8.70833C10.7248 8.92499 10.6248 9.06666 10.6248 9.29999V9.47499C10.6248 9.81666 10.3415 10.1 9.99984 10.1C9.65817 10.1 9.37484 9.81666 9.37484 9.47499V9.29999C9.37484 8.33333 10.0832 7.85833 10.3498 7.67499C10.6582 7.46666 10.7582 7.32499 10.7582 7.10833C10.7582 6.69166 10.4165 6.34999 9.99984 6.34999C9.58317 6.34999 9.2415 6.69166 9.2415 7.10833C9.2415 7.44999 8.95817 7.73333 8.6165 7.73333C8.27484 7.73333 7.9915 7.44999 7.9915 7.10833C7.9915 5.99999 8.8915 5.09999 9.99984 5.09999C11.1082 5.09999 12.0082 5.99999 12.0082 7.10833C12.0082 8.05833 11.3082 8.53333 11.0498 8.70833Z" />
      </svg>
    ),
    infoCircle: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.25" d="M12.0002 2C6.47734 2 2.00018 6.47715 2.00018 12C2.00018 17.5229 6.47734 22 12.0002 22C17.523 22 22.0002 17.5229 22.0002 12C22.0002 6.47715 17.523 2 12.0002 2Z" fill="#93AEE0" />
        <path d="M12 10.25C11.59 10.25 11.25 10.59 11.25 11V16C11.25 16.41 11.59 16.75 12 16.75C12.41 16.75 12.75 16.41 12.75 16V11C12.75 10.59 12.41 10.25 12 10.25Z" fill="#3F78E0" />
        <path
          d="M11.0802 8.38C11.1302 8.5 11.2002 8.61 11.2902 8.71C11.3902 8.8 11.5002 8.87 11.6202 8.92C11.8602 9.02 12.1401 9.02 12.3801 8.92C12.5001 8.87 12.6102 8.8 12.7101 8.71C12.8001 8.61 12.8702 8.5 12.9201 8.38C12.9702 8.26 13.0002 8.13 13.0002 8C13.0002 7.87 12.9702 7.74 12.9201 7.62C12.8702 7.49 12.8001 7.39 12.7101 7.29C12.6102 7.2 12.5001 7.13 12.3801 7.08C12.2601 7.03 12.1302 7 12.0002 7C11.8702 7 11.7402 7.03 11.6202 7.08C11.5002 7.13 11.3902 7.2 11.2902 7.29C11.2002 7.39 11.1302 7.49 11.0802 7.62C11.0302 7.74 11.0002 7.87 11.0002 8C11.0002 8.13 11.0302 8.26 11.0802 8.38Z"
          fill="#3F78E0" />
      </svg>
    ),
    code: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.4915 1.66669H6.50817C3.47484 1.66669 1.6665 3.47502 1.6665 6.50835V13.4834C1.6665 16.525 3.47484 18.3334 6.50817 18.3334H13.4832C16.5165 18.3334 18.3248 16.525 18.3248 13.4917V6.50835C18.3332 3.47502 16.5248 1.66669 13.4915 1.66669ZM8.28317 11.0584C7.7165 11.9084 6.93317 12.6 6.0165 13.0584C5.93317 13.1 5.83317 13.125 5.7415 13.125C5.50817 13.125 5.2915 13 5.18317 12.7834C5.02484 12.475 5.14984 12.1 5.4665 11.9417C6.1915 11.5834 6.80817 11.0334 7.24984 10.3667C7.39984 10.1417 7.39984 9.85835 7.24984 9.63335C6.79984 8.96669 6.18317 8.41669 5.4665 8.05835C5.14984 7.90835 5.02484 7.53335 5.18317 7.21669C5.33317 6.90835 5.70817 6.78335 6.0165 6.94169C6.93317 7.40002 7.7165 8.09169 8.28317 8.94169C8.7165 9.58335 8.7165 10.4167 8.28317 11.0584ZM14.1665 13.125H10.8332C10.4915 13.125 10.2082 12.8417 10.2082 12.5C10.2082 12.1584 10.4915 11.875 10.8332 11.875H14.1665C14.5082 11.875 14.7915 12.1584 14.7915 12.5C14.7915 12.8417 14.5082 13.125 14.1665 13.125Z" />
      </svg>
    ),
    refresh: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.0068 13.3267C10.8935 14.1667 9.50016 14.6667 8.00016 14.6667C4.32016 14.6667 2.0735 10.96 2.0735 10.96M2.0735 10.96H5.08683M2.0735 10.96V14.2933M14.6668 8.00001C14.6668 9.21334 14.3402 10.3533 13.7735 11.3333M4.02016 2.64668C5.12683 1.82001 6.50016 1.33334 8.00016 1.33334C12.4468 1.33334 14.6668 5.04001 14.6668 5.04001M14.6668 5.04001V1.70668M14.6668 5.04001H11.7068M1.3335 8.00001C1.3335 6.78668 1.6535 5.64668 2.22016 4.66668"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    firstLine: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.6665 3.75H17.4998" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.6665 7.91669H17.4998" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.5 12.0833H17.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M7.9165 7.02498V4.64165C7.9165 3.70831 7.5415 3.33331 6.59984 3.33331H4.22484C3.2915 3.33331 2.9165 3.70831 2.9165 4.64165V7.01665C2.9165 7.95831 3.2915 8.33331 4.22484 8.33331H6.59984C7.5415 8.33331 7.9165 7.95831 7.9165 7.02498Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8.375 16.25H17.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.5 16.25H4.98333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    flashWhite: (
      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.4248 8.93332H12.8498V2.93332C12.8498 1.53332 12.0914 1.24999 11.1664 2.29999L10.4998 3.05832L4.8581 9.47499C4.0831 10.35 4.4081 11.0667 5.57477 11.0667H8.14977V17.0667C8.14977 18.4667 8.9081 18.75 9.8331 17.7L10.4998 16.9417L16.1414 10.525C16.9164 9.64999 16.5914 8.93332 15.4248 8.93332Z"
          fill="white"
        />
      </svg>
    ),
    messageQuestionTwoTone: (
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.4"
          d="M14.1665 15.8584H10.8332L7.12483 18.325C6.57483 18.6917 5.83317 18.3 5.83317 17.6334V15.8584C3.33317 15.8584 1.6665 14.1917 1.6665 11.6917V6.69169C1.6665 4.19169 3.33317 2.52502 5.83317 2.52502H14.1665C16.6665 2.52502 18.3332 4.19169 18.3332 6.69169V11.6917C18.3332 14.1917 16.6665 15.8584 14.1665 15.8584Z"
          fill="#7169FB"
        />
        <path
          d="M10 10.5917C9.65834 10.5917 9.37501 10.3083 9.37501 9.96668V9.79171C9.37501 8.82504 10.0833 8.35003 10.35 8.1667C10.6583 7.95836 10.7583 7.8167 10.7583 7.60004C10.7583 7.18337 10.4167 6.84167 10 6.84167C9.58334 6.84167 9.2417 7.18337 9.2417 7.60004C9.2417 7.9417 8.95837 8.22504 8.6167 8.22504C8.27503 8.22504 7.9917 7.9417 7.9917 7.60004C7.9917 6.4917 8.89168 5.59167 10 5.59167C11.1083 5.59167 12.0083 6.4917 12.0083 7.60004C12.0083 8.55004 11.3084 9.02502 11.05 9.20002C10.725 9.41669 10.625 9.55837 10.625 9.79171V9.96668C10.625 10.3167 10.3417 10.5917 10 10.5917Z"
          fill="#7169FB"
        />
        <path
          d="M10 12.6666C9.65 12.6666 9.375 12.3833 9.375 12.0416C9.375 11.7 9.65833 11.4166 10 11.4166C10.3417 11.4166 10.625 11.7 10.625 12.0416C10.625 12.3833 10.35 12.6666 10 12.6666Z"
          fill="#7169FB"
        />
      </svg>
    ),
    dislike: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.0084 4.58333V13.05C13.0084 13.3833 12.9084 13.7083 12.7251 13.9833L10.4501 17.3667C10.0918 17.9083 9.20009 18.2917 8.44176 18.0083C7.62509 17.7333 7.08343 16.8167 7.25843 16L7.69176 13.275C7.72509 13.025 7.65843 12.8 7.51676 12.625C7.3751 12.4667 7.16676 12.3667 6.94176 12.3667H3.51676C2.85843 12.3667 2.29176 12.1 1.95843 11.6333C1.64176 11.1833 1.58343 10.6 1.79176 10.0083L3.84176 3.76666C4.10009 2.73333 5.22509 1.89166 6.34176 1.89166H9.59176C10.1501 1.89166 10.9334 2.08333 11.2918 2.44166L12.3584 3.26666C12.7668 3.58333 13.0084 4.06666 13.0084 4.58333Z" />
        <path
          d="M15.6585 14.675H16.5168C17.8085 14.675 18.3335 14.175 18.3335 12.9417V4.56668C18.3335 3.33334 17.8085 2.83334 16.5168 2.83334H15.6585C14.3668 2.83334 13.8418 3.33334 13.8418 4.56668V12.95C13.8418 14.175 14.3668 14.675 15.6585 14.675Z" />
      </svg>
    ),
    like: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.9917 15.4083V6.94166C6.9917 6.60832 7.0917 6.28332 7.27503 6.00832L9.55003 2.62499C9.90837 2.08332 10.8 1.69999 11.5584 1.98332C12.375 2.25832 12.9167 3.17499 12.7417 3.99166L12.3084 6.71666C12.275 6.96666 12.3417 7.19166 12.4834 7.36666C12.625 7.52499 12.8334 7.62499 13.0584 7.62499H16.4834C17.1417 7.62499 17.7084 7.89166 18.0417 8.35832C18.3584 8.80832 18.4167 9.39166 18.2084 9.98332L16.1584 16.225C15.9 17.2583 14.775 18.1 13.6584 18.1H10.4084C9.85003 18.1 9.0667 17.9083 8.70837 17.55L7.6417 16.725C7.23337 16.4167 6.9917 15.925 6.9917 15.4083Z" />
        <path
          d="M4.3415 5.31668H3.48317C2.1915 5.31668 1.6665 5.81668 1.6665 7.05001V15.4333C1.6665 16.6667 2.1915 17.1667 3.48317 17.1667H4.3415C5.63317 17.1667 6.15817 16.6667 6.15817 15.4333V7.05001C6.15817 5.81668 5.63317 5.31668 4.3415 5.31668Z" />
      </svg>
    ),
    profileUser: (
      <svg width="16" height="16" viewBox="0 0 11 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.10671 7.24668C6.04004 7.24001 5.96004 7.24001 5.88671 7.24668C4.30004 7.19334 3.04004 5.89334 3.04004 4.29334C3.04004 2.66001 4.36004 1.33334 6.00004 1.33334C7.63337 1.33334 8.96004 2.66001 8.96004 4.29334C8.95337 5.89334 7.69337 7.19334 6.10671 7.24668Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.77348 9.70666C1.16014 10.7867 1.16014 12.5467 2.77348 13.62C4.60681 14.8467 7.61348 14.8467 9.44681 13.62C11.0601 12.54 11.0601 10.78 9.44681 9.70666C7.62014 8.48666 4.61348 8.48666 2.77348 9.70666Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    yellowSquare: <span className="icon-square icon-square-yellow"></span>,
    redSquare: <span className="icon-square icon-square-red"></span>,
    greenSquare: <span className="icon-square icon-square-green"></span>,
    copyUrl: (
      <svg width="23" height="13" viewBox="0 0 23 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.07617 6.19223C7.07617 6.42685 7.16937 6.65185 7.33527 6.81775C7.50117 6.98365 7.72617 7.07685 7.96079 7.07685H15.0377C15.2723 7.07685 15.4973 6.98365 15.6632 6.81775C15.8291 6.65185 15.9223 6.42685 15.9223 6.19223C15.9223 5.95762 15.8291 5.73261 15.6632 5.56672C15.4973 5.40082 15.2723 5.30762 15.0377 5.30762H7.96079C7.72617 5.30762 7.50117 5.40082 7.33527 5.56672C7.16937 5.73261 7.07617 5.95762 7.07617 6.19223Z"
          fill="currentColor"
        />
        <path
          d="M8.84615 10.6154H6.19231C5.01923 10.6154 3.89421 10.1494 3.06472 9.31989C2.23523 8.49041 1.76923 7.36538 1.76923 6.19231C1.76923 5.01923 2.23523 3.89421 3.06472 3.06472C3.89421 2.23523 5.01923 1.76923 6.19231 1.76923H8.84615C9.08077 1.76923 9.30577 1.67603 9.47167 1.51013C9.63757 1.34424 9.73077 1.11923 9.73077 0.884615C9.73077 0.650001 9.63757 0.424996 9.47167 0.259098C9.30577 0.0932005 9.08077 0 8.84615 0H6.19231C4.55001 0 2.97497 0.652402 1.81368 1.81369C0.652402 2.97497 0 4.55001 0 6.19231C0 7.83461 0.652402 9.40965 1.81368 10.5709C2.97497 11.7322 4.55001 12.3846 6.19231 12.3846H8.84615C9.08077 12.3846 9.30577 12.2914 9.47167 12.1255C9.63757 11.9596 9.73077 11.7346 9.73077 11.5C9.73077 11.2654 9.63757 11.0404 9.47167 10.8745C9.30577 10.7086 9.08077 10.6154 8.84615 10.6154Z"
          fill="currentColor"
        />
        <path
          d="M16.808 0H14.1541C13.9195 0 13.6945 0.0932005 13.5286 0.259098C13.3627 0.424996 13.2695 0.650001 13.2695 0.884615C13.2695 1.11923 13.3627 1.34424 13.5286 1.51013C13.6945 1.67603 13.9195 1.76923 14.1541 1.76923H16.808C17.9811 1.76923 19.1061 2.23523 19.9356 3.06472C20.7651 3.89421 21.2311 5.01923 21.2311 6.19231C21.2311 7.36538 20.7651 8.49041 19.9356 9.31989C19.1061 10.1494 17.9811 10.6154 16.808 10.6154H14.1541C13.9195 10.6154 13.6945 10.7086 13.5286 10.8745C13.3627 11.0404 13.2695 11.2654 13.2695 11.5C13.2695 11.7346 13.3627 11.9596 13.5286 12.1255C13.6945 12.2914 13.9195 12.3846 14.1541 12.3846H16.808C18.4503 12.3846 20.0253 11.7322 21.1866 10.5709C22.3479 9.40965 23.0003 7.83461 23.0003 6.19231C23.0003 4.55001 22.3479 2.97497 21.1866 1.81369C20.0253 0.652402 18.4503 0 16.808 0Z"
          fill="currentColor"
        />
      </svg>
    ),
    infoCirclePlainDesigned: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 9.1665C10.6203 9.1665 10.3125 9.4743 10.3125 9.854V15.5832C10.3125 15.9629 10.6203 16.2707 11 16.2707C11.3797 16.2707 11.6875 15.9629 11.6875 15.5832V9.854C11.6875 9.4743 11.3797 9.1665 11 9.1665Z"
          fill="#0A2540"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 1.375C5.68425 1.375 1.375 5.68425 1.375 11C1.375 16.3157 5.68425 20.625 11 20.625C16.3157 20.625 20.625 16.3157 20.625 11C20.625 5.68425 16.3157 1.375 11 1.375ZM0 11C0 4.92484 4.92484 0 11 0C17.0752 0 22 4.92484 22 11C22 17.0752 17.0752 22 11 22C4.92484 22 0 17.0752 0 11Z"
          fill="#0A2540"
        />
        <path
          d="M12.1472 6.41678C12.1472 7.04963 11.6342 7.56264 11.0013 7.56264C10.3685 7.56264 9.85547 7.04963 9.85547 6.41678C9.85547 5.78401 10.3685 5.271 11.0013 5.271C11.6342 5.271 12.1472 5.78401 12.1472 6.41678Z"
          fill="#0A2540"
        />
      </svg>
    ),
    knowledgeBase: (
      <svg width={props?.width ?? '20'} height={props?.height ?? '20'} viewBox="0 0 20 20" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M0 5C0 2.23858 2.23858 0 5 0H14.8889C17.6503 0 19.8889 2.23858 19.8889 5V9.88889V14.7778C19.8889 17.5392 17.6503 19.7778 14.8889 19.7778H5C2.23857 19.7778 0 17.5392 0 14.7778V9.88889V5ZM2 10.8889V14.7778C2 16.4346 3.34314 17.7778 5 17.7778H14.8889C16.5457 17.7778 17.8889 16.4346 17.8889 14.7778V10.8889H2ZM17.8889 8.88889H2V5C2 3.34315 3.34315 2 5 2H14.8889C16.5457 2 17.8889 3.34315 17.8889 5V8.88889ZM4.33333 5.44444C4.33333 4.89216 4.78105 4.44444 5.33333 4.44444H11C11.5523 4.44444 12 4.89216 12 5.44444C12 5.99673 11.5523 6.44444 11 6.44444H5.33333C4.78105 6.44444 4.33333 5.99673 4.33333 5.44444ZM13 5.44444C13 4.89216 13.4477 4.44444 14 4.44444H14.5556C15.1078 4.44444 15.5556 4.89216 15.5556 5.44444C15.5556 5.99673 15.1078 6.44444 14.5556 6.44444H14C13.4477 6.44444 13 5.99673 13 5.44444ZM4.33333 14.3333C4.33333 13.781 4.78105 13.3333 5.33333 13.3333H11C11.5523 13.3333 12 13.781 12 14.3333C12 14.8856 11.5523 15.3333 11 15.3333H5.33333C4.78105 15.3333 4.33333 14.8856 4.33333 14.3333ZM13 14.3333C13 13.781 13.4477 13.3333 14 13.3333H14.5556C15.1078 13.3333 15.5556 13.781 15.5556 14.3333C15.5556 14.8856 15.1078 15.3333 14.5556 15.3333H14C13.4477 15.3333 13 14.8856 13 14.3333Z"
              fill="#0A2540" />
      </svg>
    ),
    agents: (
      <svg width={props?.width ?? '20'} height={props?.height ?? '20'} viewBox="0 0 20 20" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 10C5.97056 10 10 5.97056 10 1C10 5.97056 14.0294 10 19 10C14.0294 10 10 14.0294 10 19C10 14.0294 5.97056 10 1 10Z"
          stroke="#0A2540" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    conversations: (
      <svg
        width={props?.width ?? '22'}
        height={props?.height ?? '20'}
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.97885 6.27778H15.0212M6.97885 10.5H12.0053M15.579 16.2464L18.4044 18.6197C19.055 19.1662 20.0476 18.7037 20.0476 17.854V5C20.0476 2.79086 18.2568 1 16.0476 1H5.95239C3.74325 1 1.95239 2.79086 1.95239 5V11.7778C1.95239 13.9869 3.74325 15.7778 5.95239 15.7778H14.2926C14.7632 15.7778 15.2187 15.9437 15.579 16.2464Z"
          stroke="#0A2540"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    accountMenu: (
      <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 2C7.59644 2 2 7.59644 2 14.5C2 17.7661 3.25261 20.7396 5.30364 22.9663C6.38668 19.4376 10.2243 17 14.5 17C18.7757 17 22.6133 19.4376 23.6964 22.9663C25.7474 20.7396 27 17.7661 27 14.5C27 7.59644 21.4036 2 14.5 2ZM23.7302 25.6833C26.9488 23.0237 29 19.0014 29 14.5C29 6.49187 22.5081 0 14.5 0C6.49187 0 0 6.49187 0 14.5C0 19.0014 2.05117 23.0237 5.26983 25.6833C5.33259 25.7503 5.40448 25.8087 5.48352 25.8565C7.95878 27.8243 11.0921 29 14.5 29C17.9079 29 21.0412 27.8243 23.5165 25.8565C23.5955 25.8087 23.6674 25.7503 23.7302 25.6833ZM21.9753 24.5194C21.6721 21.5735 18.6104 19 14.5 19C10.3896 19 7.32789 21.5735 7.02471 24.5194C9.10962 26.0774 11.6971 27 14.5 27C17.3029 27 19.8904 26.0774 21.9753 24.5194ZM14.5 7C12.567 7 11 8.567 11 10.5C11 12.433 12.567 14 14.5 14C16.433 14 18 12.433 18 10.5C18 8.567 16.433 7 14.5 7ZM9 10.5C9 7.46243 11.4624 5 14.5 5C17.5376 5 20 7.46243 20 10.5C20 13.5376 17.5376 16 14.5 16C11.4624 16 9 13.5376 9 10.5Z"
          fill="#0A2540" />
      </svg>
    ),
    arrowDown: (
      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.00039 3.76385L8.30379 0.674867C8.58963 0.407582 9.03372 0.407582 9.31955 0.674867C9.63384 0.968757 9.63384 1.46725 9.31955 1.76114L5.6834 5.16128C5.299 5.52073 4.70178 5.52073 4.31739 5.16128L0.681227 1.76114C0.366938 1.46725 0.366938 0.968756 0.681228 0.674866C0.967066 0.407582 1.41115 0.407581 1.69699 0.674866L5.00039 3.76385Z"
          fill="#0A2540"
        />
      </svg>
    ),
    arrowUp: (
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.99961 6.23615L3.69621 9.32513C3.41037 9.59242 2.96628 9.59242 2.68045 9.32513C2.36616 9.03124 2.36616 8.53275 2.68045 8.23886L6.3166 4.83872C6.701 4.47927 7.29821 4.47927 7.68261 4.83872L11.3188 8.23886C11.6331 8.53275 11.6331 9.03124 11.3188 9.32513C11.0329 9.59242 10.5888 9.59242 10.303 9.32513L6.99961 6.23615Z"
          fill="#0A2540"
        />
      </svg>
    ),
    share: (
      <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_914_69039)">
          <path
            d="M17.7769 3.55314C20.0696 4.32367 22.0554 5.77225 23.4948 7.6591C25.0397 9.6861 25.9589 12.219 25.9589 14.9653C25.9589 15.5466 25.915 16.1314 25.8307 16.7091C27.9164 17.9485 28.618 20.6394 27.4068 22.7525C26.1935 24.8648 23.516 25.5948 21.4048 24.4038C19.2921 26.0836 16.682 27 13.9712 27C11.2469 27 8.60412 26.0637 6.4865 24.3633C5.52975 24.8961 4.37526 25.0726 3.2392 24.7674C0.913227 24.1427 -0.473004 21.7315 0.148532 19.3957C0.457529 18.2438 1.18395 17.3267 2.11945 16.7632C2.03015 16.1677 1.98337 15.5629 1.98337 14.9653C1.98337 12.219 2.90257 9.6861 4.44755 7.6591C5.88693 5.77225 7.87273 4.32367 10.1654 3.55314C10.2341 2.60687 10.6438 1.7538 11.2724 1.12272C11.9648 0.430446 12.9187 0 13.9712 0C15.0236 0 15.9775 0.430446 16.6678 1.12485C17.2978 1.7538 17.7082 2.60687 17.7769 3.55314ZM24.0972 16.1172C24.139 15.7373 24.1588 15.3552 24.1588 14.9653C24.1588 12.6274 23.3785 10.4737 22.0674 8.75335C20.9002 7.22296 19.3106 6.03265 17.475 5.35816C17.2822 5.80498 17.0073 6.20838 16.6699 6.54705C15.9775 7.23932 15.0236 7.66977 13.9712 7.66977C12.9187 7.66977 11.9648 7.23932 11.2745 6.54492C10.9358 6.20696 10.6608 5.80426 10.468 5.35745C8.63247 6.03194 7.04284 7.22296 5.87489 8.75335C4.56378 10.4737 3.78349 12.6274 3.78349 14.9653C3.78349 15.3716 3.80617 15.7721 3.85224 16.1705C4.38731 16.1079 4.94506 16.1442 5.49998 16.2936C7.83517 16.9212 9.21361 19.3317 8.58924 21.6653C8.44112 22.2203 8.19165 22.7226 7.86706 23.1566C9.62537 24.4806 11.7494 25.1928 13.9712 25.1928C16.1681 25.1928 18.278 24.492 20.0264 23.1922C18.9994 21.8126 18.8272 19.8973 19.7386 18.3107C20.6507 16.7205 22.3913 15.9123 24.0972 16.1172ZM25.8533 21.8503C26.5798 20.5888 26.1432 18.9688 24.8874 18.241C23.6308 17.5117 22.0171 17.95 21.2921 19.2107C20.5657 20.4722 21.0022 22.0922 22.2581 22.82C23.5146 23.5493 25.1283 23.111 25.8533 21.8503ZM3.70341 23.0242C5.0783 23.3935 6.48579 22.5817 6.85361 21.2C7.22143 19.8212 6.41209 18.4046 5.03719 18.0368C3.66514 17.6682 2.2541 18.48 1.88557 19.861C1.51846 21.2391 2.32781 22.655 3.70341 23.0242ZM15.3978 2.39911C15.0363 2.03412 14.5317 1.80787 13.9719 1.80787C13.412 1.80787 12.9074 2.03412 12.5459 2.39769C12.1817 2.76695 11.9556 3.27637 11.9556 3.8356C11.9556 4.39482 12.1817 4.90424 12.5459 5.26994C12.9074 5.63707 13.412 5.86332 13.9719 5.86332C14.5317 5.86332 15.0363 5.63707 15.3978 5.2735C15.7621 4.90424 15.9881 4.39482 15.9881 3.8356C15.9881 3.27637 15.7621 2.76695 15.3978 2.39911Z"
            fill="#0A2540"
          />
        </g>
        <defs>
          <clipPath id="clip0_914_69039">
            <rect width="28" height="27" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    editData: (
      <svg
        width={props?.width ?? '28'}
        height={props?.height ?? '29'}
        viewBox="0 0 28 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.2673 0.25716C23.4047 0.117494 23.5855 0.0286877 23.78 0.00532379C23.9098 -0.0091534 24.041 0.00598905 24.1642 0.0496098C24.2872 0.0932305 24.3988 0.164193 24.4905 0.25716L27.7461 3.51307C27.8266 3.59329 27.8904 3.6886 27.934 3.79355C27.9776 3.89851 28 4.01103 28 4.12467C28 4.2383 27.9776 4.35081 27.934 4.45577C27.8904 4.56072 27.8266 4.65604 27.7461 4.73627L25.0431 7.43952C25.049 7.52585 25.052 7.61299 25.052 7.70081V25.2413C25.052 27.3172 23.3696 29 21.2942 29H3.7578C1.68243 29 0 27.3172 0 25.2413V7.70081C0 5.62496 1.68243 3.94213 3.7578 3.94213H19.5827L23.2673 0.25716ZM24.4123 5.60232C24.1411 5.19994 23.794 4.85289 23.3917 4.58167L22.3906 3.58052L23.8789 2.09197L25.9114 4.12467L24.4232 5.6132L24.4123 5.60232ZM18.0793 5.4456H3.7578C2.51258 5.4456 1.50312 6.4553 1.50312 7.70081V25.2413C1.50312 26.4868 2.51258 27.4965 3.7578 27.4965H21.2942C22.5394 27.4965 23.5489 26.4868 23.5489 25.2413V8.93381L13.3025 19.181C13.1733 19.3104 13.0064 19.3953 12.8259 19.4238L8.9586 20.0354C8.82378 20.057 8.68574 20.0463 8.55585 20.0042C8.42594 19.9623 8.30787 19.89 8.21132 19.7934C8.11477 19.6968 8.04249 19.5787 8.00042 19.4488C7.95835 19.3189 7.94769 19.1808 7.96931 19.046L8.58086 15.1786C8.60931 14.9979 8.69432 14.831 8.82368 14.7019L18.0793 5.4456ZM20.5256 5.4456H21.2942C21.4999 5.4456 21.6992 5.47316 21.8884 5.52476L23.2 6.8364L12.2772 17.7599L9.86693 18.1377L10.2447 15.7272L20.5256 5.4456Z"
          fill="#0A2540"
        />
      </svg>
    ),
    trash: (
      <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.500089 3.68749H2.37503L2.37514 16.5C2.37514 16.8315 2.5068 17.1494 2.74124 17.3839C2.97567 17.6184 3.29361 17.75 3.62505 17.75H12.375C12.7065 17.75 13.0244 17.6183 13.2589 17.3839C13.4933 17.1495 13.6249 16.8315 13.6249 16.5V3.68749H15.4999L15.5 2.43747H10.8125V1.50002C10.8125 1.16847 10.6808 0.850556 10.4464 0.616098C10.2119 0.38164 9.89398 0.25 9.56254 0.25H6.43746C6.10602 0.25 5.78811 0.381662 5.55365 0.616098C5.31919 0.850534 5.18755 1.16847 5.18755 1.50002V2.43758L0.5 2.43747L0.500089 3.68749ZM12.3751 16.5H3.62508V3.68749H12.3751V16.5ZM6.43758 1.5H9.56266V2.43755L6.43758 2.43744V1.5Z"
          fill="currentColor"
        />
      </svg>
    ),
    pencil: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17.2045 3.51573L16.4807 2.79158C15.9589 2.2695 15.2686 2 14.5784 2C13.8881 2 13.1979 2.2695 12.676 2.79158L2.81089 12.6611C2.6257 12.8463 2.50792 13.0821 2.47422 13.3347L2.00285 17.36C1.96915 17.7137 2.23853 18 2.5752 18H2.64249L6.66598 17.5284C6.91845 17.4947 7.17105 17.3769 7.33931 17.1916L17.2044 7.32211C18.2652 6.27781 18.2652 4.57682 17.2046 3.51579L17.2045 3.51573ZM4.24184 12.9305L12.3562 4.81258L15.1843 7.64199L7.07 15.7599L4.24184 12.9305ZM3.61898 14.042L5.959 16.383L3.29912 16.6861L3.61898 14.042ZM16.346 6.47986L16.043 6.78296L13.2149 3.95354L13.5178 3.65044C13.804 3.36414 14.1744 3.21257 14.5616 3.21257C14.9487 3.21257 15.336 3.36413 15.6053 3.65044L16.3291 4.37459C16.6153 4.66089 16.7668 5.03143 16.7668 5.41877C16.7837 5.82301 16.6322 6.19357 16.346 6.47986H16.346Z"
          fill="currentColor"
        />
      </svg>
    ),
    synchronization: (
      <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.41698 12.8127C1.17189 12.8127 0.988069 12.6971 0.865522 12.5238C0.252788 11.4263 -0.0535783 10.271 0.007695 9.058C0.007695 4.95676 3.62282 1.60645 7.97323 1.60645C8.34087 1.60645 8.58596 1.8375 8.58596 2.18409C8.58596 2.53067 8.34087 2.76172 7.97323 2.76172C4.29683 2.76172 1.23316 5.59216 1.23316 9.058C1.23316 10.04 1.47826 11.0797 1.96844 11.9462C2.15226 12.235 2.02972 12.5816 1.72335 12.6971C1.66208 12.7549 1.53953 12.8127 1.41698 12.8127Z"
          fill="currentColor"
        />
        <path
          d="M7.97406 16.5092C7.60642 16.5092 7.36133 16.2781 7.36133 15.9315C7.36133 15.5849 7.60642 15.3539 7.97406 15.3539C11.6505 15.3539 14.7141 12.5235 14.7141 9.05761C14.7141 8.07562 14.469 7.03587 13.9788 6.16941C13.795 5.88059 13.9176 5.53401 14.2239 5.36072C14.5303 5.18743 14.8979 5.30295 15.0818 5.59177C15.6945 6.68929 16.0009 7.84457 16.0009 9.05761C15.9396 13.1589 12.3245 16.5092 7.97406 16.5092Z"
          fill="currentColor"
        />
        <path
          d="M10.8532 1.77942L8.27975 0.0465036C8.1572 -0.0690244 7.91211 0.0465035 7.91211 0.219795V4.08998C7.91211 4.26327 8.1572 4.3788 8.27975 4.26327L10.8532 2.12601C10.9758 2.01048 10.9758 1.83719 10.8532 1.77942Z"
          fill="currentColor"
        />
        <path
          d="M7.66734 13.7946L5.09386 15.5276C4.97132 15.5853 4.97132 15.7586 5.09386 15.8164L7.66734 17.9536C7.78989 18.0692 8.03498 17.9536 8.03498 17.7803V13.9102C8.03498 13.7946 7.85116 13.7369 7.66734 13.7946Z"
          fill="currentColor"
        />
      </svg>
    ),
    cross: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.19243 7.77821L14.8496 13.4354C15.2401 13.8259 15.2401 14.459 14.8496 14.8494C14.4592 15.2399 13.8261 15.2399 13.4356 14.8494L7.77843 9.19221L2.12121 14.8494C1.73075 15.2399 1.09768 15.2399 0.707213 14.8494C0.316747 14.459 0.316748 13.8259 0.707213 13.4354L6.36443 7.77821L0.707212 2.121C0.316748 1.73053 0.316748 1.09746 0.707213 0.706999C1.09768 0.316534 1.73075 0.316534 2.12121 0.707L7.77843 6.36421L13.4356 0.707C13.8261 0.316534 14.4592 0.316535 14.8496 0.707C15.2401 1.09747 15.2401 1.73053 14.8496 2.121L9.19243 7.77821Z"
          fill="currentColor"
        />
      </svg>
    ),
    history: (
      <svg width={props?.width ?? '20'} height={props?.height ?? '20'} viewBox="0 0 20 20" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M5 0C2.23858 0 0 2.23858 0 5V6C0 6.55228 0.447715 7 1 7C1.55228 7 2 6.55228 2 6V5C2 3.34315 3.34315 2 5 2H15C16.6569 2 18 3.34315 18 5V6C18 6.55228 18.4477 7 19 7C19.5523 7 20 6.55228 20 6V5C20 2.23858 17.7614 0 15 0H5ZM2 14C2 13.4477 1.55228 13 1 13C0.447715 13 0 13.4477 0 14V15C0 17.7614 2.23858 20 5 20H15C17.7614 20 20 17.7614 20 15V14C20 13.4477 19.5523 13 19 13C18.4477 13 18 13.4477 18 14V15C18 16.6569 16.6569 18 15 18H5C3.34315 18 2 16.6569 2 15V14ZM10 5.99997C7.7909 5.99997 6.00003 7.79083 6.00003 9.99997C6.00003 12.2091 7.7909 14 10 14C12.2092 14 14 12.2091 14 9.99997C14 7.79083 12.2092 5.99997 10 5.99997ZM4.00003 9.99997C4.00003 6.68626 6.68633 3.99997 10 3.99997C13.3137 3.99997 16 6.68626 16 9.99997C16 13.3137 13.3137 16 10 16C6.68633 16 4.00003 13.3137 4.00003 9.99997ZM9.5662 7.07407C10.1185 7.07407 10.5662 7.52179 10.5662 8.07407V10.2136H11.9209C12.4732 10.2136 12.9209 10.6614 12.9209 11.2136C12.9209 11.7659 12.4732 12.2136 11.9209 12.2136H9.5662C9.01391 12.2136 8.5662 11.7659 8.5662 11.2136V8.07407C8.5662 7.52179 9.01391 7.07407 9.5662 7.07407Z"
              fill="#0A2540" />
      </svg>
    ),
    reports: (
      <svg width={props?.width ?? '22'}
           height={props?.height ?? '21'} viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M0.952393 5.04687C0.952393 2.28545 3.19097 0.046875 5.95239 0.046875H16.2266C18.988 0.046875 21.2266 2.28545 21.2266 5.04688V15.1688C21.2266 17.9302 18.988 20.1688 16.2266 20.1688H5.95239C3.19097 20.1688 0.952393 17.9302 0.952393 15.1688V5.04687ZM5.95239 2.04688C4.29554 2.04688 2.95239 3.39002 2.95239 5.04687V15.1688C2.95239 16.8256 4.29554 18.1688 5.95239 18.1688H16.2266C17.8834 18.1688 19.2266 16.8256 19.2266 15.1688V5.04688C19.2266 3.39002 17.8834 2.04688 16.2266 2.04688H5.95239ZM11.0895 5.37685C11.6418 5.37685 12.0895 5.82456 12.0895 6.37685V15.4378C12.0895 15.9901 11.6418 16.4378 11.0895 16.4378C10.5372 16.4378 10.0895 15.9901 10.0895 15.4378V6.37685C10.0895 5.82456 10.5372 5.37685 11.0895 5.37685ZM15.1504 8.57483C15.7027 8.57483 16.1504 9.02254 16.1504 9.57483V15.4378C16.1504 15.9901 15.7027 16.4378 15.1504 16.4378C14.5981 16.4378 14.1504 15.9901 14.1504 15.4378V9.57483C14.1504 9.02254 14.5981 8.57483 15.1504 8.57483ZM7.02856 10.7068C7.58084 10.7068 8.02856 11.1545 8.02856 11.7068V15.4378C8.02856 15.9901 7.58084 16.4378 7.02856 16.4378C6.47627 16.4378 6.02856 15.9901 6.02856 15.4378V11.7068C6.02856 11.1545 6.47627 10.7068 7.02856 10.7068Z"
              fill="#0A2540" />
      </svg>
    ),
    send: (
      <svg
        width={props?.width ?? '20'}
        height={props?.height ?? '20'}
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4433 12.9851L7.05397 11.8871C6.86719 11.8437 6.72044 11.6703 6.69375 11.4536L6.10673 5.31324C6.09339 5.13986 5.85325 5.13986 5.82656 5.31324L5.27957 11.4536C5.26623 11.6703 5.11947 11.8437 4.93269 11.8871L0.556718 12.9851C0.183159 13.0862 -0.123693 12.6528 0.0497452 12.2772L5.59976 0.2709C5.7732 -0.0902999 6.25349 -0.0902999 6.42693 0.270899L11.9503 12.2772C12.1237 12.6528 11.8168 13.0862 11.4433 12.9851Z"
          fill="white"
        />
      </svg>
    ),
    menu: (
      <svg
        width={props?.width ?? '20'}
        height={props?.height ?? '20'}
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.55556 1H4.85714C2.7269 1 1 2.7269 1 4.85714V4.85714V15C1 17.2091 2.79086 19 5 19H6.55556M6.55556 1H17.1429C19.2731 1 21 2.7269 21 4.85714V4.85714V15C21 17.2091 19.2091 19 17 19H6.55556M6.55556 1V19"
          stroke="#0A2540"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    newChat: (
      <svg
        width={props?.width ?? '20'}
        height={props?.height ?? '20'}
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.4571 0.829658C18.3797 -0.247759 16.6399 -0.282385 15.5246 0.764306C15.2852 0.988912 15.0189 1.23932 14.7308 1.51076C13.0334 3.11048 10.7819 5.24189 8.87695 7.12782C7.92524 8.07003 7.05224 8.95866 6.37526 9.69312C6.03719 10.0599 5.7406 10.3962 5.50478 10.6865C5.28298 10.9596 5.06793 11.2482 4.93891 11.5062C4.46488 12.4543 4.23285 13.3902 4.11777 14.0807C4.05984 14.4283 4.03048 14.7202 4.01556 14.9291C4.00809 15.0337 4.0042 15.118 4.00218 15.1786C4.00117 15.2089 4.00063 15.2334 4.00033 15.2515L4.00006 15.274L4.00001 15.2816L4 15.2845L4 15.2857L4 15.2863C4 15.2865 4 15.2868 5 15.2868H4C4 15.552 4.10536 15.8063 4.29289 15.9939C4.48043 16.1814 4.73478 16.2868 5 16.2868V15.2868C5 16.2868 5.00025 16.2868 5.00051 16.2868H5.00105L5.00226 16.2868L5.00515 16.2868L5.01277 16.2867L5.03525 16.2864C5.05341 16.2861 5.07786 16.2856 5.10818 16.2846C5.16881 16.2826 5.2531 16.2787 5.35771 16.2712C5.56658 16.2563 5.85845 16.2269 6.20607 16.169C6.89656 16.0539 7.8325 15.8219 8.78055 15.3479C9.03859 15.2188 9.3272 15.0038 9.60024 14.782C9.89054 14.5462 10.2269 14.2496 10.5936 13.9115C11.3281 13.2345 12.2167 12.3615 13.1589 11.4098C15.0449 9.5049 17.1763 7.25341 18.776 5.55594C19.0474 5.26791 19.2979 5.00155 19.5225 4.7622C20.5692 3.64682 20.5345 1.90707 19.4571 0.829658ZM7.88612 13.559C7.27479 13.8647 6.65471 14.0439 6.13872 14.148C6.24284 13.6321 6.4221 13.012 6.72776 12.4006C6.7512 12.3538 6.84387 12.2101 7.05713 11.9476C7.25636 11.7023 7.52216 11.3998 7.84586 11.0486C8.49243 10.3471 9.34056 9.48319 10.2841 8.5491C11.918 6.93146 13.8146 5.12646 15.3964 3.63242L16.6543 4.8904C15.1603 6.4722 13.3553 8.36878 11.7377 10.0027C10.8036 10.9462 9.93963 11.7943 9.23815 12.4409C8.88696 12.7646 8.58446 13.0304 8.3392 13.2296C8.07668 13.4429 7.933 13.5356 7.88612 13.559ZM18.0263 3.43388L16.8529 2.26051L16.8932 2.22271C17.2168 1.91898 17.7249 1.92586 18.0429 2.24387C18.3609 2.56189 18.3678 3.06994 18.0641 3.3936L18.0263 3.43388ZM2 4.85715C2 3.2792 3.27919 2.00001 4.85714 2.00001H7C7.55228 2.00001 8 1.55229 8 1.00001C8 0.447724 7.55228 8.88378e-06 7 8.88378e-06H4.85714C2.17462 8.88378e-06 0 2.17463 0 4.85715V15C0 17.7614 2.23858 20 5 20H6H15C17.7614 20 20 17.7614 20 15V13C20 12.4477 19.5523 12 19 12C18.4477 12 18 12.4477 18 13V15C18 16.6569 16.6569 18 15 18H6H5C3.34315 18 2 16.6569 2 15V4.85715Z"
          fill="#0A2540"
        />
      </svg>
    ),
    accounts: (
      <svg width={props?.width ?? '24'} height={props?.height ?? '20'} viewBox="0 0 24 20" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0ZM7 5C7 3.34315 8.34315 2 10 2C11.6569 2 13 3.34315 13 5C13 6.65685 11.6569 8 10 8C8.34315 8 7 6.65685 7 5Z"
          fill="#0A2540" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 11C7.3881 11 4.97389 11.5463 3.17604 12.4777C1.42837 13.3831 0 14.8108 0 16.6625C0 17.6198 0.399169 18.3857 1.10987 18.9151C1.75884 19.3986 2.60874 19.642 3.47784 19.7812C4.93086 20.014 6.83432 20.0058 8.83927 19.9972C9.22303 19.9955 9.61126 19.9938 10 19.9938C10.3887 19.9938 10.7762 19.9955 11.16 19.9971C13.1649 20.0058 15.0691 20.014 16.5222 19.7812C17.3913 19.642 18.2412 19.3986 18.8901 18.9151C19.6008 18.3857 20 17.6198 20 16.6625C20 14.8108 18.5716 13.3831 16.824 12.4777C15.0261 11.5463 12.6119 11 10 11ZM2 16.6625C2 15.9392 2.58634 15.0357 4.09604 14.2535C5.55555 13.4974 7.64133 13 10 13C12.3587 13 14.4444 13.4974 15.904 14.2535C17.4137 15.0357 18 15.9392 18 16.6625C18 16.9928 17.8955 17.1621 17.6953 17.3112C17.4335 17.5063 16.9653 17.6847 16.2058 17.8064C14.9299 18.0108 13.2324 18.0044 11.2195 17.9968C10.8249 17.9954 10.4181 17.9938 10 17.9938C9.58193 17.9938 9.17518 17.9954 8.78055 17.9968C6.76768 18.0044 5.07013 18.0108 3.79423 17.8064C3.03466 17.6847 2.56653 17.5063 2.30466 17.3112C2.10451 17.1621 2 16.9928 2 16.6625Z"
          fill="#0A2540" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.75 5C20.75 4.58579 20.4142 4.25 20 4.25C19.5858 4.25 19.25 4.58579 19.25 5C19.25 6.24264 18.2426 7.25 17 7.25C16.5858 7.25 16.25 7.58579 16.25 8C16.25 8.41421 16.5858 8.75 17 8.75C18.2426 8.75 19.25 9.75736 19.25 11C19.25 11.4142 19.5858 11.75 20 11.75C20.4142 11.75 20.75 11.4142 20.75 11C20.75 9.75736 21.7574 8.75 23 8.75C23.4142 8.75 23.75 8.41421 23.75 8C23.75 7.58579 23.4142 7.25 23 7.25C21.7574 7.25 20.75 6.24264 20.75 5ZM19.2504 8C19.5342 7.78676 19.7868 7.53418 20 7.25037C20.2132 7.53418 20.4658 7.78676 20.7496 8C20.4658 8.21324 20.2132 8.46582 20 8.74963C19.7868 8.46582 19.5342 8.21324 19.2504 8Z"
          fill="#0A2540" />
      </svg>
    ),
    burgerMenu: (
      <svg width={props?.width ?? '19'} height={props?.height ?? '19'} viewBox="0 0 19 19" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 0.95C0 0.425329 0.425329 0 0.95 0H18.05C18.5747 0 19 0.425329 19 0.95C19 1.47467 18.5747 1.9 18.05 1.9H0.95C0.425329 1.9 0 1.47467 0 0.95Z"
          fill="#0A2540" />
        <path
          d="M0 9.5C0 8.97533 0.425329 8.55 0.95 8.55H18.05C18.5747 8.55 19 8.97533 19 9.5C19 10.0247 18.5747 10.45 18.05 10.45H0.95C0.425329 10.45 0 10.0247 0 9.5Z"
          fill="#0A2540" />
        <path
          d="M0.95 17.1C0.425329 17.1 0 17.5253 0 18.05C0 18.5747 0.425329 19 0.95 19H18.05C18.5747 19 19 18.5747 19 18.05C19 17.5253 18.5747 17.1 18.05 17.1H0.95Z"
          fill="#0A2540" />
      </svg>
    ),
    paperClip: (
      <svg width={props?.width ?? '16'} height={props?.height ?? '27'} viewBox="0 0 16 27" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.74925 26.8562C5.69469 26.854 3.7249 26.0369 2.2721 24.5841C0.819302 23.1313 0.00216007 21.1615 -2.76566e-05 19.1069V6.39541C-2.76566e-05 6.12138 0.108829 5.85857 0.302599 5.6648C0.496368 5.47103 0.759177 5.36217 1.03321 5.36217C1.30724 5.36217 1.57005 5.47103 1.76382 5.6648C1.95759 5.85857 2.06645 6.12138 2.06645 6.39541V19.1069C2.06645 20.6141 2.66517 22.0596 3.7309 23.1253C4.79663 24.191 6.24208 24.7898 7.74925 24.7898C9.25643 24.7898 10.7019 24.191 11.7676 23.1253C12.8333 22.0596 13.4321 20.6141 13.4321 19.1069V5.43583C13.4164 4.53268 13.0467 3.6718 12.4024 3.03863C11.7582 2.40547 10.8911 2.05067 9.98776 2.05067C9.08447 2.05067 8.21733 2.40547 7.5731 3.03863C6.92887 3.6718 6.55911 4.53268 6.54347 5.43583V19.1069C6.54347 19.4267 6.6705 19.7334 6.89663 19.9596C7.12276 20.1857 7.42946 20.3127 7.74925 20.3127C8.06905 20.3127 8.37575 20.1857 8.60187 19.9596C8.828 19.7334 8.95504 19.4267 8.95504 19.1069V6.39541C8.95504 6.12138 9.0639 5.85857 9.25767 5.6648C9.45144 5.47103 9.71425 5.36217 9.98828 5.36217C10.2623 5.36217 10.5251 5.47103 10.7189 5.6648C10.9127 5.85857 11.0215 6.12138 11.0215 6.39541V19.1069C11.0215 19.9748 10.6768 20.8071 10.0631 21.4208C9.44943 22.0345 8.61711 22.3792 7.74925 22.3792C6.8814 22.3792 6.04908 22.0345 5.43541 21.4208C4.82175 20.8071 4.47699 19.9748 4.47699 19.1069V5.43583C4.49683 3.98735 5.08615 2.60492 6.11746 1.58763C7.14878 0.570342 8.53915 0 9.98776 0C11.4364 0 12.8267 0.570342 13.8581 1.58763C14.8894 2.60492 15.4787 3.98735 15.4985 5.43583V19.1069C15.4963 21.1615 14.6792 23.1313 13.2264 24.5841C11.7736 26.0369 9.80382 26.854 7.74925 26.8562Z"
          fill="#0A2540" />
      </svg>

    ),
  }

  return (
    <span
      {...props}
      className={`anticon icon ${className}`}
      style={{ fill, stroke, cursor: props?.onClick ? 'pointer' : 'inherit', ...style }}
    >
      {icons[name]}
    </span>
  )
}

export default memo(Icon)
